"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderBookWebSocket = void 0;
const rxjs_1 = require("rxjs");
const CacheData_1 = require("./base/CacheData");
const SubsPairMgr_1 = require("./base/SubsPairMgr");
const BaseWebSocket_1 = require("./BaseWebSocket");
const QuotationSocketMgr_1 = require("./QuotationSocketMgr");
class OrderBookWebSocket extends BaseWebSocket_1.BaseWebSocket {
    constructor() {
        super(...arguments);
        this.subject = new rxjs_1.BehaviorSubject(new Map());
        this.orderBookCacheData = new CacheData_1.CacheData([], new rxjs_1.BehaviorSubject([]));
        this.orderBookPairPoolMgr = new SubsPairMgr_1.SubsPairMgr(QuotationSocketMgr_1.SubscribeEventType.orderBook, (type, param) => {
            return this.send(QuotationSocketMgr_1.SubscribeEventType.orderBook, param);
        });
    }
    handleOrderBookData(pushData) {
        if (!pushData || pushData.length === 0) {
            return;
        }
        const orderbookMap = this.subject.getValue();
        for (let orderbook of pushData) {
            const bids = [];
            const asks = [];
            if (orderbook.d && orderbook.d.length) {
                orderbook.d.forEach((item) => {
                    const entry = {
                        price: parseFloat(item[0]),
                        quantity: parseFloat(item[1]),
                    };
                    bids.push(entry);
                });
            }
            if (orderbook.a && orderbook.a.length) {
                orderbook.a.forEach((item) => {
                    const entry = {
                        price: parseFloat(item[0]),
                        quantity: parseFloat(item[1]),
                    };
                    asks.push(entry);
                });
            }
            const data = {
                market: orderbook.e,
                base: orderbook.b,
                quote: orderbook.q,
                bids: bids,
                asks: asks,
            };
            orderbookMap.set(`${data.base}/${data.quote}`, data);
        }
        this.subject.next(orderbookMap);
    }
    /**
     * 订阅OrderBook推送
     * [{
     *    exchange: "pionex.v2",
     *    base: base,
     *    quote: quote,
     * }]
     * @param exchange
     * @param base
     * @param quote
     */
    getOrderBookObservable(exchange, base, quote) {
        this.orderBookPairPoolMgr.addSubscribePair([{ market: exchange, base: base, quote: quote }]);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.subject.subscribe((result) => {
                const orderbook = result.get(`${base}/${quote}`);
                if (orderbook) {
                    observer.next(orderbook);
                }
            }, (err) => {
                console.log(err);
            });
            observer.add(() => {
                subscription.unsubscribe();
                const deleted = this.orderBookPairPoolMgr.removeSubscribePair([
                    {
                        market: exchange,
                        base: base,
                        quote: quote,
                    },
                ]);
                if (deleted.length > 0) {
                    const map = this.subject.getValue();
                    for (let pair of deleted) {
                        map.delete(`${pair.base}/${pair.quote}`);
                    }
                }
            });
        });
    }
    getOrderBookBatchObservable(pairInfoList) {
        this.orderBookPairPoolMgr.addSubscribePair(pairInfoList);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.subject.subscribe((result) => {
                pairInfoList.map((pair) => {
                    const symbol = `${pair.base}/${pair.quote}`;
                    const orderbook = result.get(symbol);
                    if (orderbook) {
                        observer.next(orderbook);
                    }
                });
            }, (err) => {
                console.log(err);
            });
            observer.add(() => {
                subscription.unsubscribe();
                const deleted = this.orderBookPairPoolMgr.removeSubscribePair(pairInfoList);
                if (deleted.length > 0) {
                    const map = this.subject.getValue();
                    for (let pair of deleted) {
                        map.delete(`${pair.base}/${pair.quote}`);
                    }
                }
            });
        });
    }
    getOrderBookMapObservable(pairInfoList) {
        this.orderBookPairPoolMgr.addSubscribePair(pairInfoList);
        return new rxjs_1.Observable((observer) => {
            const subscription = this.subject.subscribe((result) => {
                observer.next(pairInfoList.reduce((map, pair) => {
                    const symbol = `${pair.base}/${pair.quote}`;
                    map.set(symbol, result.get(symbol));
                    return map;
                }, new Map()));
            }, (err) => {
                console.log(err);
            });
            observer.add(() => {
                subscription.unsubscribe();
                const deleted = this.orderBookPairPoolMgr.removeSubscribePair(pairInfoList);
                if (deleted.length > 0) {
                    const map = this.subject.getValue();
                    for (let pair of deleted) {
                        map.delete(`${pair.base}/${pair.quote}`);
                    }
                }
            });
        });
    }
}
exports.OrderBookWebSocket = OrderBookWebSocket;
